import { classNames } from "@indietabletop/appkit/class-names";
import * as css from "./style.css";

const icons = {
  back: (
    <g strokeWidth="1.25" fill="none">
      <polygon
        transform="translate(11.5, 12) scale(-1, 1) rotate(90) translate(-11.5, -12)"
        points="11.5 7.5 16.5 16.5 6.5 16.5"
      />
    </g>
  ),
  cross: (
    <g strokeWidth="1.25" fill="none" strokeLinecap="square">
      <line x1="7" y1="7" x2="17" y2="17" />
      <line x1="17" y1="7" x2="7" y2="17" />
    </g>
  ),
  divider: (
    <g strokeWidth="1.25" fill="none" strokeLinecap="square">
      <line x1="8.5" y1="21.5" x2="15.5" y2="2.5" />
    </g>
  ),
  forward: (
    <g strokeWidth="1.25" fill="none">
      <polygon
        transform="translate(12.5, 12) rotate(90) translate(-12.5, -12)"
        points="12.5 7.5 17.5 16.5 7.5 16.5"
      />
    </g>
  ),
  locked: (
    <g strokeWidth="1.25" fill="none" strokeLinecap="square">
      <g transform="translate(6, 4)">
        <polygon points="0 6 12 6 12 16 1.6636692e-13 16" />
        <path d="M9,5.38134766 L9,3 C9,1.34314575 7.65685425,0 6,0 C4.34314575,0 3,1.34314575 3,3 L3,5.38134766" />
        <polygon points="6 9 8 13 4 13" />
      </g>
    </g>
  ),
  menu: (
    <g strokeWidth="1.25" fill="none">
      <circle cx="3" cy="11.5" r="2.5" />
      <circle cx="12" cy="11.5" r="2.5" />
      <circle cx="21" cy="11.5" r="2.5" />
    </g>
  ),
};

export type IconName = keyof typeof icons;

export function Icon(props: {
  name: IconName;
  title?: string;
  className?: string;
}) {
  const { name, title } = props;
  const icon = icons[name];

  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(css.icon, props.className)}
    >
      {title && <title>{title}</title>}
      {icon}
    </svg>
  );
}
